// extracted by mini-css-extract-plugin
module.exports = {"flex":"style__flex__DWK7R","siteLabel":"style__siteLabel__4RcUa","modalFooter":"style__modalFooter__TODHi","siteNameLabel":"style__siteNameLabel__wliyx"};